export function sortTypes(a, b) {
  if (a.equipment_type_name == 'Miscellaneous') {
    return 1;
  }

  if (b.equipment_type_name == 'Miscellaneous') {
    return -1;
  }

  if (a.equipment_type_name > b.equipment_type_name) {
    return 1;
  } else if (a.equipment_type_name < b.equipment_type_name) {
    return -1;
  }

  return 0
}

export function sortSubtypes(a, b) {
  const aSubtype = a.equipment_sub_type_name ? a.equipment_sub_type_name : a;
  const bSubtype = b.equipment_sub_type_name ? b.equipment_sub_type_name : b;

  if (aSubtype == 'Miscellaneous') {
    return 1;
  }

  if (bSubtype == 'Miscellaneous') {
    return -1;
  }

  if (aSubtype > bSubtype) {
    return 1;
  } else if (aSubtype < bSubtype) {
    return -1;
  }

  return 0
}

export function sortMarketTypes(a, b) {
  const aMarketType = a.name ? a.name : a;
  const bMarketType = b.name ? b.name : b;

  if (aMarketType == 'Miscellaneous') {
    return 1;
  }

  if (bMarketType == 'Miscellaneous') {
    return -1;
  }

  if (aMarketType > bMarketType) {
    return 1;
  } else if (aMarketType < bMarketType) {
    return -1;
  }

  return 0
}